import { LocalizationConfig } from "../models"
import { translateText } from "./translate"

export function getWeekDays(config: LocalizationConfig): Array<string> {
    return [
        translateText(config, 533),
        translateText(config, 527),
        translateText(config, 528),
        translateText(config, 529),
        translateText(config, 530),
        translateText(config, 531),
        translateText(config, 532),
    ]
}

export function getMonths(config: LocalizationConfig): Array<string> {
    return [
        translateText(config, 507),
        translateText(config, 508),
        translateText(config, 509),
        translateText(config, 510),
        translateText(config, 511),
        translateText(config, 512),
        translateText(config, 513),
        translateText(config, 514),
        translateText(config, 515),
        translateText(config, 516),
        translateText(config, 517),
        translateText(config, 518),
    ]
}

export function getDecimalSeparator(language: string = "de"): string {
    // Format number into a decimal number using local (e.g. de-DE -> "1,1")
    const formatted = new Intl.NumberFormat(getSupportedLocal(language)).format(1.1)

    // Remove all digits and return the decimal separator itself as string
    return formatted.replace(/[0-9]/g, "").trim()
}

export function getThousandSeparator(language: string = "de"): string {
    // Format number into a number (with thousand separator) using local (e.g. de-DE -> "1.000")
    const formatted = new Intl.NumberFormat(getSupportedLocal(language)).format(1000)

    // Remove all digits and return the thousand separator itself as string
    return formatted.replace(/[0-9]/g, "").trim()
}

export function getSupportedLocal(language: string): string {
    try {
        // If the browser language includes the next language, use (localized) browser language instead
        const combinationNextLangAndBrowserLang = navigator.language.toLowerCase().startsWith(language.toLowerCase())
            ? navigator.language
            : Intl.NumberFormat.supportedLocalesOf(language)[0]

        return combinationNextLangAndBrowserLang || navigator.language
    } catch (error) {
        // Fallback: return the browser language
        return navigator.language
    }
}
